import skeleton from '../../../components/skeleton';
import vueSeamlessScroll from "vue-seamless-scroll";
import banner from "../../../components/banner";
import caseList from "../../../components/caseList";
import news from "../../../components/news";
import pay from "../../../components/pay";
import QRCode from "../../../components/QRCode";
import maskPDF from "../../../components/maskPDF";
import customerTalk from "../../../components/customerTalk";
import './caseRetail.less'
export default {
    name: "caseRetail",
    data() {
        return {
            black:{
                title: '从使用收款小精灵的第一个超市至今，从社区超市到购物广场，从母婴店到药店连锁，从店内到线上，我们为零售商户提供整合的数字解决方案',
                info: '我们帮助传统商超便利店打通线上和线下，不仅可以快速对接您的传统收银台，还可以在门店进行小程序扫码购、自助收银等自助服务，为用户提供便捷的购物体验；同时，小精灵的小程序商城和外卖，帮助零售商家实现线上线下会员一体化，对用户进行精准触达。'
            },
            rollList: [
                {
                    src: "img/caseRetail/roll1.png",
                    size: 4,
                },
                {
                    src: "img/caseRetail/roll2.png",
                    size: 2,
                },
                {
                    src: "img/caseRetail/roll3.png",
                    size: 3,
                },
                {
                    src: "img/caseRetail/roll4.png",
                    size: 4,
                },
                {
                    src: "img/caseRetail/roll5.png",
                    size: 2,
                },
            ],
            data: {
                title: '具备单品回传能力，并稳定',
                info: [
                    {
                        num: '20万+',
                        title: '零售商户',
                        line: false
                    },
                    {
                        line: true
                    },
                    {
                        num: '4亿+',
                        title: '消费者',
                        line: false
                    },
                    {
                        line: true
                    },
                    {
                        num: '2000万+',
                        title: '商户会员',
                        line: false
                    },
                    {
                        line: true
                    },
                    {
                        num: '280万+',
                        title: '商品',
                        line: false
                    }
                ]
            },
            caseData: {
                title: '零售行业洞察及解决方案',
                info: [
                    {
                        title: '小精灵数字零售概述',
                        pic: 'img/caseRetail/case1.png',
                        linkTxt: '行业概述',
                        linkType: 'href',
                        linkHref: 'https://www.yuque.com/lt/jjfa/vruy0l'
                    },
                    {
                        title: '超商便利店解决方案',
                        pic: 'img/caseRetail/case2.png',
                        linkTxt: '解决方案',
                        linkType: 'href',
                        linkHref: 'https://www.yuque.com/lt/jjfa/wyq52a'
                    },
                    {
                        title: '服饰专卖解决方案',
                        pic: 'img/caseRetail/case3.png',
                        linkTxt: '解决方案',
                        linkType: 'href',
                        linkHref: 'https://www.yuque.com/lt/jjfa/dyp313'
                    },
                    {
                        title: '购物中心解决方案',
                        pic: 'img/caseRetail/case4.png',
                        linkTxt: '解决方案',
                        linkType: 'href',
                        linkHref: 'https://www.yuque.com/lt/jjfa/oe2lq1'
                    },
                    {
                        title: '药店解决方案',
                        pic: 'img/caseRetail/case5.png',
                        linkTxt: '解决方案',
                        linkType: 'href',
                        linkHref: 'https://www.yuque.com/lt/jjfa/gdvpif'
                    },
                    {
                        title: '母婴零售解决方案',
                        pic: 'img/caseRetail/case6.png',
                        linkTxt: '解决方案',
                        linkType: 'href',
                        linkHref: ''
                    }
                ]
            },
            supermarket: {
                title: '超市和便利店',
                more: '更多超市案例',
                num: 3,
                info: [
                    {
                        pic: "/img/caseRetail/supermarket1.png",
                        title: "地区性连锁标超【平安超市】仅用5个月实现千万储值",
                        txt: "短短5个月，从上线小精灵电子会员卡，业绩迅速翻倍，他们是如何做到的？",
                        pdf: "https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/anli/懒熊火锅超市.pdf",
                    },
                    {
                        pic: "/img/caseRetail/supermarket2.png",
                        title: "新消费品牌标杆【懒熊火锅超市】用“企业钱包”资金能力助力规模化拓展",
                        txt: "全国加盟连锁品牌利用收款小精灵数字化系统助力于快速拓店。",
                        pdf: "https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/anli/平安超市.pdf",
                    },
                    {
                        pic: "/img/caseRetail/supermarket3.png",
                        title: "一家【医院超市】启发全国700万家便利小超市的改变",
                        txt: "回顾2020年，新冠疫情极大冲击了传统零售行业的经营方式，线下线上融合无疑是更好的选择。",
                        pdf: "https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/anli/医院超市.pdf",
                    },

                    {
                        pic: "/img/caseRetail/supermarket4.png",
                        title: "“拼团+秒杀”攻占社区，【和美超市】一个月时间营业额增长50万",
                        txt: "和美超市上线外卖商城，仅一个月的时间，和美超市会员就超过了一万人，7家门店营业总额比平时增长50万元。",
                        pdf: ""
                    },
                    {
                        pic: "/img/caseRetail/supermarket5.png",
                        title: "【九州正上超市】20天储值60万，一家传统商超的增长秘籍",
                        txt: "使用小精灵插件打通商品数据库，用高毛利商品优惠带动消费，社群结合互动营销，把储值做起来。",
                        pdf: ""
                    },
                    {
                        pic: "/img/caseRetail/supermarket6.png",
                        title: "一个小程序，让【广州海洋大学】的复购率增长75%",
                        txt: "2018年12月，海洋大学超市上线了电子会员，3秒开卡，学生利用积分兑换商品和券。不到半年时间，开卡13000+，占总人数的40%。",
                        pdf: ""
                    },
                    {
                        pic: "/img/caseRetail/supermarket7.png",
                        title: "【年年香】超市用优惠券撬动会员权益，8个月时间储值破千万",
                        txt: "会员等级建设，结合不同等级的会员权益，鼓励会员高额储值，储值线上线下通用，拉动顾客储值动力。",
                        pdf: ""
                    },
                    {
                        pic: "/img/caseRetail/supermarket8.png",
                        title: "生鲜超市【爽又甜】一个月会员突破2万+，让传统生意人扔掉账本",
                        txt: "从书面笔记本记账会员到电子会员，7级会员，储值营销，结合爆款单品，一天换购200个西瓜！上线当月即吸粉2万+",
                        pdf: ""
                    },
                    {
                        pic: "/img/caseRetail/supermarket9.png",
                        title: "异业发券，交叉引流，【义乌双江时代】淘金10万会员",
                        txt: "把10万会员根据消费次数、金额、年纪等划分为10几个标签，然后精准发券，轻松触达10万会员，国庆活动券核销率17%",
                        pdf: ""
                    },
                ]
            },
            customerTalk1: {
                bg: 'rgb(245, 233, 225)',
                pic: 'img/caseRetail/person1.png',
                info: '“我们超市之前的会员积分有363万，折算成费用要支出145.2万，现在全部转成小精灵电子会员卡的余额，不转就清零，这让原来‘沉睡’的几万个会员全都激活了。”',
                person: '— 徐女士，平安超市， 门店运营经理'
            },
            shopping: {
                title: '购物广场',
                more: '更多购物广场案例',
                num: 3,
                info: [
                    {
                        pic: "/img/caseRetail/shopping1.png",
                        title: "门店数1200家＋的【生龙国际时尚广场】如何利用统一会员管理将门店业绩提升33.5%",
                        txt: "2个月的筹备，最终实现了1200+门店的数字化升级：统一会员、统一积分、统一营销、统一管理...门店业绩平均提升33.5%。",
                        pdf: "https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/anli/升龙国际.pdf",
                    },
                    {
                        pic: "/img/caseRetail/shopping2.png",
                        title: "20万平购物广场广州【流花展贸中心】上线3天会员开卡20000+",
                        txt: "传统国企，正逢转型1周年，借力小精灵实现数字化全面升级：收银、支付、会员、积分、代运营、停车...五一期间上线，三天开卡2万+会员。",
                        pdf: "https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/anli/流花展贸中心.pdf",
                    },
                    {
                        pic: "/img/caseRetail/shopping3.png",
                        title: "北京【万科万优汇】，如何用商圈小程序搭建商圈私域流量，吸纳上千商户入驻",
                        txt: "万科旗下商圈液态，定制化商圈小程序，圈店入驻、智慧停车、拼团秒杀、商城售卖...仅用1周吸纳上千商户入驻，快速构建私域流量变现。",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRetail/shopping4.png",
                        title: "一夜之间涨粉4万+，揭秘【新世纪广场】的流量秘籍",
                        txt: "第一期活动目的是：拉新，活动前一天：购物广场员工和商家员工集体将开卡二维码发送至朋友圈，邀约开卡：开卡即送停车券，仅用2天时间，实现4万人次开卡，超出目标200%！",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRetail/shopping5.png",
                        title: "【九州正上超市】20天储值60万，一家传统商超的增长秘籍",
                        txt: "使用小精灵插件打通商品数据库，用高毛利商品优惠带动消费，社群结合互动营销，把储值做起来。",
                        pdf: "",
                    },
                ]
            },
            customerTalk2: {
                bg: 'rgb(225, 229, 245)',
                pic: 'img/caseRetail/person2.png',
                info: '“收款小精灵的整体数字化方案十分灵活。我们从停车场的扫码付费场景为入口，积累线上会员和积分，开展商铺之间的异业营销，业绩得到快速提升”',
                person: '— 高先生，广州流花中心， 运营主管'
            },
            baby: {
                title: '母婴零售店',
                more: '更多母婴零售案例',
                num: 3,
                info: [
                    {
                        pic: "/img/caseRetail/baby1.png",
                        title: "热门亲子IP【DINITIANDI迪尼天地童装】商城小程序直播，日均线上交易30000+",
                        txt: "45家结盟连锁品牌，半年积累8万电子会员。疫情期间转战线上，搭建商城小程序，每晚直播都有上万人次观看，销售额至少30000+，抗疫同时实现创收",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRetail/baby2.png",
                        title: "从传统记账会员到电子会员【好妈妈孕婴童】仅用一招覆盖周边3个小区93%目标客户",
                        txt: "母婴行业贯穿整个孕产周期及婴幼童成长周期，客户群体非常精准，客户生命周期很长。社群营销结合拓客营销，好妈妈充分利用社交属性完成销售额的翻倍",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRetail/baby3.png",
                        title: "20年区域连锁老店【宝贝1+1】，通过30个会员精准标签，把会员复购率做到每周1.7次",
                        txt: "20年历史老店，有6家店面，涵盖有婴儿游泳、婴儿摄影、产后恢复等服务项目的连锁机构，通过会员精准分层，用30多个会员标签精准会员画像，实现人均1.7次/周的复购",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRetail/baby4.png",
                        title: "【万州好孩子】，仅用一招，把积分兑换率做到70%",
                        txt: "开卡、消费、推荐都可以积分，运用积分商城，兑换纸尿裤、牛奶杯、儿童玩具等引流商品，会员日可双倍积分，他们家把积分玩出了花样",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRetail/baby5.png",
                        title: "推荐有礼结合储值，攻陷宝妈群，【贝贝拉姆】的社群玩法很聪明",
                        txt: "开卡就是儿童袜，自己储值或者推荐新人储值即可进入宝马学习群，定期分享宝马带娃课程，就用这一招，一个月储值突破60万+！",
                        pdf: "",
                    },
                ]
            },
            customerTalk3: {
                bg: 'rgb(245, 233, 225)',
                pic: 'img/caseRetail/person3.png',
                info: '“主动营销与被动营销只差一个好的系统，好的系统是运营策划成功的前提。 母婴是一个对社群很依赖的行业，小精灵针对社群的工具和运营方式简单且有效”',
                person: '— 邱女士， 迪尼天地 ，连锁运营总监'
            },
            pharmacy: {
                title: '药店连锁',
                more: '更多药店案例',
                num: 3,
                info: [
                    {
                        pic: "/img/caseRetail/pharmacy1.png",
                        title: "百年老字号【同仁堂】巧用积分和在线问诊，3个月实现峰值流水翻番",
                        txt: "中华老字号，百年同仁堂，电子会员卡结合公众号，积分商城结合在线问诊，1周完成全面升级，短短三个月实现流水的翻倍增长。",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRetail/pharmacy2.png",
                        title: "成都【三元大药房】商城小程序爆款商品单日秒杀破2600单",
                        txt: "64个门店的区域连锁品牌，打造支付+公众号+电子会员+小程序的完整体系电子会员覆盖成都近10万消费者，上线商城单日秒杀即突破2600单。",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRetail/pharmacy3.png",
                        title: "河北【普济医药】储值卡结合会员等级和权益，深度吸储做增收",
                        txt: "三级会员，结合不同储值额度升级，享受不同权益和会员价。加上门店强执行和考核，仅用3月储值卡破300万+",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRetail/pharmacy4.png",
                        title: "【烟台益佰口腔】在线售卖疗程次卡，一张会员卡优化顾客销售体验",
                        txt: "连锁口腔门诊，会员开卡可以直接在线购买洗牙、拔牙、拍片、种植牙等套餐，还可储值升级VIP会员，极大优化了顾客体验。",
                        pdf: "",
                    },
                ]
            },
            customerTalk4: {
                bg: 'rgb(225, 229, 245)',
                pic: 'img/caseRetail/person4.png',
                info: '“传统药店其实还有很大提升空间可以挖掘，一体化的解决方案、便捷有效的触达、数据驱动的运营策略，在这个行业出效果很显著”',
                person: '— 邓先生，三元大药房， 运营服务商'
            },
            clothes: {
                title: '服饰专卖',
                more: '更多服饰专卖店案例',
                num: 3,
                info: [
                    {
                        pic: "/img/caseRetail/clothes1.png",
                        title: "哈尔滨【胜道体育】用20万会员重新定义直播",
                        txt: "在各种直播带货大行其道的时候，胜道体育把直播市场定位在了自有小程序商城直播上，每晚2小时，内部人员自己直播，峰值突破百万销售额！",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRetail/clothes2.png",
                        title: "【阿拉丁童装】商城小程序结合拼团秒杀，快速积累线上3万会员",
                        txt: "区域连锁童装品牌，充分利用家长的社交属性，线下推荐有礼，结合线上拼团秒杀，双管齐下，3个月积累3万会员。",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRetail/clothes3.png",
                        title: "【完美的爱】内衣品牌，积分消耗率45%，让积分真正的动起来",
                        txt: "电子会员卡实现积分可视化，用积分商城实现积分的消耗，积分换购商品券、代金券，让积分活起来！",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRetail/clothes4.png",
                        title: "临沂【悦悦体育】老会员复购超过3.5次，它是怎么做到的呢？",
                        txt: "在各种直播带货大行其道的时候，胜道体育把直播市场定位在了自有小程序商城直播上，每晚2小时，内部人员自己直播，峰值突破百万销售额！",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseRetail/clothes5.png",
                        title: "【CAP on】通过消费有礼每满减，让门店客单价提高15%",
                        txt: "饰品店，消费有礼每满赠，力度10%，鼓励顾客冲击更高阶梯的满赠额度，从而达到提高门店客单价的效果。",
                        pdf: "",
                    },
                ]
            },
            customerTalk5: {
                bg: 'rgb(245, 233, 225)',
                pic: 'img/caseRetail/person5.png',
                info: '“淘宝、抖音等直播带货我们都有尝试，但是平台抽成、主播抽成都很高。所以当我们自己搭建了自己的商城小程序的时候，我们果断的选择了小程序直播，职员自己直播，一年可以省下来几百万的费用”',
                person: '— 方女士， 圣道体育 ，哈尔滨区域运营总监'
            },
        }
    },
    components: {
        skeleton,
        banner,
        caseList,
        news,
        customerTalk,
        pay,
        QRCode,
        maskPDF,
        vueSeamlessScroll
    },
    computed: {
        classOption() {
            return {
                step: 0.7, // 数值越大速度滚动越快
                limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: false, // 是否开启鼠标悬停stop
                direction: 2, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            };
        },
    }
}
